module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-coj_e-493b462bcf4fab430b506f04919abc68.jpg";